import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Center, SkeletonText } from '@chakra-ui/react';
import 'react-quill/dist/quill.snow.css';
import { useAppSelector, useGetFaqByIdQuery } from '@spartalabs/pdc-core';
import { Container, EmptyCard, ErrorCard } from 'components';
import { CardSkele } from 'components/Skeletons/Card';
import { HtmlStlyed } from '../components/HtmlParser';
import { FaQSearch } from '../components/Search';

export const FaqQuestion: React.FC = () => {
  const { id } = useParams();

  const permissions = useAppSelector(
    state => state.authSlicer.user.permissions,
  );

  const { data, isLoading, isError, refetch } = useGetFaqByIdQuery({
    id: id || '',
  });

  return (
    <Container bg="white">
      <FaQSearch
        titleLoading={isLoading}
        direction={-1}
        title={data?.title}
        desc={data?.desc}
        canEdit={permissions?.includes('faq')}
        id={id}
      />

      {isError ? (
        <ErrorCard border="0px" boxShadow="0px" refetch={refetch} />
      ) : isLoading ? (
        <Center flexDirection="column">
          <Box mt="40px" ml="10%" mr="auto">
            <CardSkele w="200px" h="20px">
              <></>
            </CardSkele>
          </Box>
          <SkeletonText
            w="80%"
            mx="auto"
            mt="4"
            noOfLines={10}
            spacing="4"
            skeletonHeight="2"
            mb="16px"
          />
          <CardSkele w="60%" h="400px">
            <></>
          </CardSkele>

          <SkeletonText
            mt="16px"
            w="80%"
            mx="auto"
            noOfLines={10}
            spacing="4"
            skeletonHeight="2"
          />
        </Center>
      ) : !data?.desc && !data?.title ? (
        <EmptyCard
          backTo="/centraldeduvidas"
          mt="40px"
          border="0px"
          boxShadow="0px"
        />
      ) : (
        <HtmlStlyed mt="28px" title={data?.title} value={data?.htmlContent} />
      )}
    </Container>
  );
};
